export default __webpack_public_path__ + "media/elisaVid.6ebfb7aa.mp4";